import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateWebhookMutationVariables = Types.Exact<{
  input: Types.CreateWebhookInput;
}>;

export type CreateWebhookMutation = {
  __typename?: 'Mutation';
  createWebhook: {
    __typename?: 'Webhook';
    id: any;
    ownerUserId?: any | null;
    ownerTeamId?: any | null;
    type: Types.WebhookType;
    label: string;
    url: string;
    method: string;
    createdAt: any;
  };
};

export const CreateWebhookDocument = gql`
  mutation CreateWebhook($input: CreateWebhookInput!) {
    createWebhook(input: $input) {
      id
      ownerUserId
      ownerTeamId
      type
      label
      url
      method
      createdAt
    }
  }
`;
export type CreateWebhookMutationFn = Apollo.MutationFunction<
  CreateWebhookMutation,
  CreateWebhookMutationVariables
>;

/**
 * __useCreateWebhookMutation__
 *
 * To run a mutation, you first call `useCreateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookMutation, { data, loading, error }] = useCreateWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebhookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWebhookMutation,
    CreateWebhookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWebhookMutation,
    CreateWebhookMutationVariables
  >(CreateWebhookDocument, options);
}
export type CreateWebhookMutationHookResult = ReturnType<
  typeof useCreateWebhookMutation
>;
export type CreateWebhookMutationResult =
  Apollo.MutationResult<CreateWebhookMutation>;
export type CreateWebhookMutationOptions = Apollo.BaseMutationOptions<
  CreateWebhookMutation,
  CreateWebhookMutationVariables
>;
